import { render } from "./Bienvenue.vue?vue&type=template&id=00ea5f0a"
import script from "./Bienvenue.vue?vue&type=script&lang=js"
export * from "./Bienvenue.vue?vue&type=script&lang=js"

import "./Bienvenue.vue?vue&type=style&index=0&id=00ea5f0a&lang=scss"
script.render = render

export default script